var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currThemeObj.cssStyle),expression:"currThemeObj.cssStyle"}],staticClass:"football_cup_svgSingleCircle",class:_vm.dynamicClass,style:({
    '--mixtmt_strokeWidth': `${_vm.strokeWidth * 2}px`,
    '--mixtmt_svgWidth': `${_vm.cx * 2}px`,
    '--mixtmt_svgCenterBgColor1_1': `${_vm.svgCenterBgColorArr[0]}`,
    '--mixtmt_svgCenterBgColor1_2': `${_vm.svgCenterBgColorArr[1]}`,
    '--mixtmt_svgCenterColor_total': `${_vm.svgCenterColorArr[0]}`,
    '--mixtmt_svgCenterColor_totalName': `${_vm.svgCenterColorArr[1]}`,
  })},[_c('div',{staticClass:"svg_area",style:({ width: `${_vm.cx * 2}px`, height: `${_vm.cx * 2}px` })},[_c('span',{staticClass:"svgBg",style:({
        width: `${_vm.cx * 2 - _vm.strokeWidth * 2}px`,
        height: `${_vm.cx * 2 - _vm.strokeWidth * 2}px`,
      })}),(_vm.renderSvgArr)?_c('svg',{attrs:{"width":_vm.cx * 2,"height":_vm.cx * 2,"viewbox":_vm.viewbox}},[_c('defs',[(_vm.teamMode === 'home')?_c('linearGradient',{attrs:{"id":"gradHome","x1":"0%","y1":"0%","x2":"100%","y2":"0%"}},[_c('stop',{style:({
              'stop-color':
                _vm.progress === 0
                  ? 'transparent'
                  : _vm.currThemeObj.cssStyle.svgSingleColor1_1,
            }),attrs:{"offset":(100 - _vm.progress) / 100}}),_c('stop',{style:({
              'stop-color':
                _vm.progress === 0
                  ? 'transparent'
                  : _vm.currThemeObj.cssStyle.svgSingleColor1_2,
            }),attrs:{"offset":"100%"}})],1):_vm._e(),(_vm.teamMode === 'away')?_c('linearGradient',{attrs:{"id":"gradAway","x1":"0%","y1":"0%","x2":"100%","y2":"0%"}},[_c('stop',{style:({
              'stop-color':
                _vm.progress === 0
                  ? 'transparent'
                  : _vm.currThemeObj.cssStyle.svgSingleColor2_1,
            }),attrs:{"offset":(100 - _vm.progress) / 100}}),_c('stop',{style:({
              'stop-color':
                _vm.progress === 0
                  ? 'transparent'
                  : _vm.currThemeObj.cssStyle.svgSingleColor2_2,
            }),attrs:{"offset":"100%"}})],1):_vm._e()],1),_vm._l((_vm.renderSvgArr),function(item,index){return _c('circle',{key:index,class:[
          index == 0
            ? 'svg_bgColor'
            : _vm.teamMode == 'home'
            ? 'svg_homeColor'
            : 'svg_awayColor',
        ],attrs:{"cx":_vm.cx,"cy":_vm.cy,"r":_vm.r,"stroke-linecap":"round","stroke-width":_vm.strokeWidth,"fill":"none","transform":`matrix(0,-1,1,0,0,${_vm.cx * 2})`,"stroke-dasharray":item}})})],2):_vm._e(),_c('div',{staticClass:"svg_infor",class:_vm.svgCenterInforArr.length == 2 ? 'center2Row' : ''},[(_vm.svgCenterInforArr.includes('val'))?_c('span',{staticClass:"svg_infor_total",style:({
          fontSize:
            _vm.svgCenterInforArr.length == 2
              ? _vm.svgCenterInforTextFontSizeArr[0]
              : _vm.svgCenterInforTextFontSizeArr[2],
        })},[_c('NumberScrolling',{attrs:{"tarVal":_vm.svgData[_vm.keyArr[1]],"unit":_vm.svgData.ceil ? _vm.svgData.ceil : ''}})],1):_vm._e(),(_vm.svgCenterInforArr.includes('name'))?_c('span',{staticClass:"svg_infor_totalName",style:({ fontSize: _vm.svgCenterInforTextFontSizeArr[1] }),domProps:{"textContent":_vm._s(`${_vm.svgData[_vm.keyArr[0]]}`)}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }